import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 一般【不要修改此文件】：业务逻辑应在 index.config.tsx 中修改
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { router } from '@libs/mvvm';
import css from './index.less';
import { AppConfig } from '@/index.config';
import { isInIFrame } from '@/utils/isInIFrame';

// 智能用例独立子项目：移除埋点上报 initTrackReport（避免周期性发后端接口）
var Entry = /*#__PURE__*/function (_React$Component) {
  function Entry() {
    _classCallCheck(this, Entry);
    return _callSuper(this, Entry, arguments);
  }
  _inherits(Entry, _React$Component);
  return _createClass(Entry, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Router, null, router.renderRouterEntry(), AppConfig.renderMainNode(), this.props.extraNode);
    }
  }]);
}(React.Component);
var DIV_ID = 'LA_Entry_ID';
export function clear() {
  var container = document.getElementById(DIV_ID);
  if (container) {
    ReactDOM.unmountComponentAtNode(container);
  }
}
export function start() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  clear();
  var container = document.getElementById(DIV_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = DIV_ID;
  }
  if (container) {
    container.classList.add(css.app);
    if (isInIFrame()) {
      container.classList.add(css.iframe_app);
    }
    document.body.appendChild(container);
    ReactDOM.render(/*#__PURE__*/React.createElement(Entry, props), container);
  }
}
export default start;